import type { TooltipProviderProps } from "@radix-ui/react-tooltip";
import { createContext, useContext } from "react";

/**
 * Context to determine if the tooltip is hidden.
 */
const TooltipContext = createContext(false);

export const HiddenTooltipProvider = TooltipContext.Provider;

export function useIsTooltipHidden(): boolean {
	return useContext(TooltipContext);
}

/**
 * Context to provide collision boundaries to the tooltip.
 */
const TooltipCollisionBoundaryContext = createContext<ReadonlyArray<Element>>([]);

export const TooltipCollisionBoundaryProvider = TooltipCollisionBoundaryContext.Provider;

export function useTooltipCollisionBoundaries(): Array<Element> {
	return useContext(TooltipCollisionBoundaryContext) as Array<Element>;
}

/**
 * Radix `Tooltip.Provider` config, held in a synchronous context so each tooltip
 * can apply it locally instead of the app being wrapped in a lazy provider.
 */
export type TooltipConfig = Omit<TooltipProviderProps, "children">;

const TooltipConfigContext = createContext<TooltipConfig>({
	delayDuration: 700,
});

export const TooltipConfigContextProvider = TooltipConfigContext.Provider;

export function useTooltipConfig(): TooltipConfig {
	return useContext(TooltipConfigContext);
}
